import DOMPurify from 'dompurify';

const DOM_PURIFY_BYPASS_ATTRIBUTE_PATTERN =
  /\s*dom-purify-bypass(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>"']+))?/gi;

export const sanitizeRichTextHtml = (html: string): string =>
  DOMPurify.sanitize(html.replace(DOM_PURIFY_BYPASS_ATTRIBUTE_PATTERN, ''));
